module.exports = __webpack_public_path__ + "5c0daa3ea73b54fa47be5f661f5cd52c.svg";